<template>
  <CriteriaSelectionCompontent
    v-if="!hasSelected"
    :year-id="yearId"
    :team-id="teamId"
    :branchYear="branchYear"
    :team-level-id="teamLevelId"
    :team-init-select="true"></CriteriaSelectionCompontent>
  <div v-else>
    <v-sheet class="border-opacity-25 border-thin rounded-lg pa-5" width="100%">
      You have selected the following Criteria that you must do:
      <v-data-iterator :items="teamCriteriaData?.data" item-value="id">
        <template v-slot:default="{ items, isExpanded, toggleExpand }">
          <v-row>
            <v-col v-for="item in items" :key="item.raw.criteria?.id">
              <v-card>
                <v-card-title class="d-flex align-center">
                  <h4>{{ item.raw.criteria?.name }}</h4>
                </v-card-title>

                <v-card-text>
                  <div v-html="item.raw.criteria?.description"></div>

                  <div
                    v-if="item.raw.criteria?.thubmnail"
                    class="d-flex justify-center align-center">
                    <v-img :src="item.raw.criteria?.thubmnail.url">
                      <template #sources>
                        <source :srcset="item.raw.criteria.thubmnail?.webp_url" />
                      </template>
                    </v-img>
                  </div>
                  <vue3-video-player
                    v-if="item.raw.criteria?.video"
                    :src="item.raw.criteria.video.url"
                    preload="false"></vue3-video-player>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-sheet>
  </div>
</template>
<script setup lang="ts">
import CriteriaSelectionCompontent from '@/components/criteria/CriteriaSelectionCompontent.vue';
import { BranchYearDTO } from '@/dtos';
import { useCriteriaStore, useRegistrationStore } from '@/stores';
import { computed } from 'vue';
interface Props {
  teamId: string;
  yearId: string;
  branchYear?: BranchYearDTO;
}
const props = defineProps<Props>();

const teamId = computed(() => props.teamId ?? '');
const yearId = computed(() => props.yearId ?? '');
const branchYear = computed(() => props.branchYear ?? new BranchYearDTO());
const criteriaStore = useCriteriaStore();
const { data: teamCriteriaData } = criteriaStore.getTeamsCriteriaQuery(yearId, teamId);
const registrationStore = useRegistrationStore();
const { data: myRegistration } = registrationStore.getMyRegistration;

const teamLevelId = computed(() => {
  return myRegistration?.teamLevel?.id;
});

const hasSelected = computed(() => {
  return (teamCriteriaData.value?.count && teamCriteriaData.value?.count > 0) ?? false;
});
</script>

<!-- TODO
1. Make it look pretty
-->
